import SelectedCountriesHandler from '../../utils/selected-countries-handler';
import CountriesModule from '../../modules/countries-module';
import CertificatesModule from '../../modules/certificates-module';

class Main {
	constructor() {
        this.metaDescription = document.getElementById('meta-description');
        this.moduleType = 'certificates';
		this.selCountries = new SelectedCountriesHandler();
		this.countriesModule = new CountriesModule(this.selCountries, true);
		this.certificatesModule = new CertificatesModule(this.countriesModule, null, this.moduleType);
	}

	run() {
        if (!!this.metaDescription) {
            document.title = 'Schulabschlüsse mit Hochschulzugang - anabin: Infoportal zu ausländischen Bildungsabschlüssen';
            this.metaDescription.setAttribute('content', 'Informationen zur Bewertung ausländischer Schulabschlüsse mit Berechtigung für den Hochschulzugang.');
        }
		this.countriesModule.getBvCountries().then(() => {
            this.countriesModule.initialiseModules(this.certificatesModule)
            const firstSelectedCountry = this.selCountries.getAllSelectedCountries()?.[0]
            if (!!firstSelectedCountry) {
                this.countriesModule.selectCountry(null, firstSelectedCountry)
            }
            this.countriesModule.renderCountryOption(this.countriesModule.countries);
			this.initializeModules();
		});
	}

	initializeModules() {
        this.certificatesModule.initialise();
	}
}
const main = new Main();
main.run();


